import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import GlobalSnackbar from "../../../shared/utils/GlobalSnackbar";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter";
import Decrypt from "../../../shared/utils/Decrypt";
import RefreshIcon from "@mui/icons-material/Refresh";
import GlobalDropdownField from "../../../shared/utils/GlobalDropdownField";

import { FormControl, InputLabel, Select, Menu, MenuItem } from "@mui/material";
import { CircularProgress, Tooltip, IconButton } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Styles from "../../../styles/vendorDashboard.module.css";
import FormatDateTimestamp from "../../../helperFunctions/FormatDateTimestamp";
import UserOnboardingForm from "./UserOnboardingForm";
import UserViewModal from "./UserViewModal";
import CustomLoading from "../../../shared/utils/CustomLoading";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import { User_plus } from "../../../shared/assets/icons/index";
import styles from "../../../styles/adminPortal.module.css";
import DeletedUsersRestore from "../../../shared/createForms/DeletedUsersRestore";

function EnhancedTableHead(props) {
  let role = localStorage.getItem("role");

  const hasActiveFilters = Object.values(props.searchInputs || {}).some(
    (value) => value && value.toString().trim() !== "",
  );

  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {props.headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {["state", "city", "name"].includes(headCell.id) && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder={`Search`}
                  onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                  value={props.searchInputs?.[headCell.id] || ""}
                />
              )}
              {headCell.id === "role" && (
                <GlobalDropdownField
                  name="role"
                  variant="searchDropdown"
                  /* 👇 value will be NUMBER (0–6) */
                  value={props.searchInputs?.[headCell.id] ?? ""}
                  onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                  placeholder="Select Role"
                  /* 👇 label is shown, value is sent */
                  options={[
                    { value: 0, label: "Client Servicing Manager" },
                    { value: 1, label: "Business Development" },
                    { value: 2, label: "Management Trainee" },
                    { value: 3, label: "Purchase" },
                    { value: 4, label: "Operations Manager" },
                    { value: 5, label: "IP Manager" },
                    { value: 6, label: "Store Onboarding Executive" },
                    { value: 7, label: "Designer Manager" },
                  ]}
                  /* 👇 dropdown shows label automatically */
                  renderValueFn={(selected) =>
                    props.ROLE_OPTIONS.find((o) => o.value === selected)?.label
                  }
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>

      {/* Only show count when there are active filters AND filteredIPCount > 0 */}
      {props.filteredIPCount > 0 && hasActiveFilters && (
        <TableRow>
          <TableCell
            colSpan={props.headCells.length}
            sx={{
              backgroundColor: "#DEEBFF",
              position: "relative",
              paddingBottom: "2rem",
            }}
          >
            <div className="fixed left-1/2 transform -translate-x-1/2 text-sm font-medium">
              {`${props.filteredIPCount} Users`}
            </div>
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const [rotate, setRotate] = useState(false);

  const handleOpen = (e) => {
    props.OnModalOpen(true);
    props.setSelectedUserData({});
  };

  const handleClickRefresh = () => {
    // Clean all filters
    props.setSearchInputs({
      state: "",
      city: "",
      name: "",
    });

    setRotate(true);
    props.userVenderData();
    props.setPageSize(10);
    setTimeout(() => setRotate(false), 500);
  };
  const handleTrashOpen = async (e) => {
    props.getALLDeletedUsers();
    props.OnTrashModalOpen(true);
  };

  return (
    <div className="border-b flex justify-between items-center h-14 pt-2">
      <div className="font-bold text-md text-gray-600">
        Total Team Member: {props.totalUsers}
      </div>
      <div className="flex">
        <Tooltip title="Refresh">
          <IconButton
            onClick={handleClickRefresh}
            sx={{
              animation: rotate ? "rotateAnimation 0.5s ease-in-out" : "none",
              "@keyframes rotateAnimation": {
                "0%": { transform: "rotate(0deg)" },
                "100%": { transform: "rotate(360deg)" },
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>

        {localStorage.getItem("role") != "1" && (
          <Tooltip title="Add User">
            <IconButton onClick={handleOpen}>
              <User_plus sx={{ color: "#666666" }} />
            </IconButton>
          </Tooltip>
        )}
        {localStorage.getItem("role") == "-1" && (
          <>
            <Tooltip title="Trash">
              <IconButton onClick={handleTrashOpen}>
                <DeleteOutlinedIcon sx={{ color: "#666666" }} />
              </IconButton>
            </Tooltip>
          </>
        )}
      </div>
    </div>
  );
}
var oldData = [];
export default function EnhancedTable() {
  // Declare states
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImage, setIsImage] = useState(false);

  const [isVerified, setIsVerified] = useState(false);
  const [details, setDetails] = useState(null);
  const [pageSize, setPageSize] = useState(100);
  const pageSizeOptions = [1, 5, 10, 50, 100, 200];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isMapState, setIsMapState] = useState(false);
  const [isTrashModalOpen, setIsTrashModalOpen] = useState(false);
  const [allDeletedUsers, setALLDeletedUsers] = useState([]);
  const [isTrashLoading, setTrashLoading] = useState(false);

  const [filteredIPCount, setFilteredIPCount] = useState(0);
  const [user, setUser] = useState([]);

  const [selectedUserData, setSelectedUserData] = useState({});
  const [userListLoading, setUserListLoading] = useState(true);
  const [totalUsers, setTotalUsers] = useState("0");
  let debounceTimeout = null;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null); // Store the selected row ID
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
    name: "",
  });
  const ROLE_MAP = {
    "-1": "Super Admin",
    0: "Client Servicing Manager",
    1: "Business Development",
    2: "Management Trainee",
    3: "Purchase",
    4: "Operations Manager",
    5: "IP Manager",
    6: "Store Onboarding Executive ",
    7: "Designer Manager",
  };

  const ROLE_OPTIONS = [
    { value: 0, label: "Client Servicing Manager" },
    { value: 1, label: "Business Development" },
    { value: 2, label: "Management Trainee" },
    { value: 3, label: "Purchase" },
    { value: 4, label: "Operations Manager" },
    { value: 5, label: "IP Manager" },
    { value: 6, label: "Store Onboarding Executive" },
    { value: 6, label: "Designer Manager" },
  ];
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [headCells, setHeadCells] = useState([]);

  useEffect(() => {
    const baseHeadCells = [
      { id: "name", label: "Name", width: 200 },
      { id: "email", label: "Email", width: 200 },
      { id: "phoneNumber", label: "Phone Number", width: 160 },
      { id: "role", label: "Role", width: 300 },
      { id: "state", label: "State", width: 160 },
      { id: "city", label: "City", width: 140 },
      { id: "createdAt", label: "Added On", width: 160 },
      { id: "action", label: "Action", width: 80 },
    ];

    setHeadCells(baseHeadCells);
  }, []);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getUserList = async (page = 1, limit = 10) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/users/get?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setTotalUsers(response?.data?.totalRecords);
        setUser(response?.data?.data);
        oldData = response?.data?.data;
        setTotalPages(response?.data?.totalPages);
        setUserListLoading(false);
      }
    } catch (error) {
      console.error("Error fetching User:", error);
    }
  };

  useEffect(() => {
    // Only filter if both dates are set
    if (searchInputs.fromDate && searchInputs.toDate) {
      const queryParams = new URLSearchParams();
      Object.entries(searchInputs).forEach(([key, value]) => {
        if (value && value.trim() !== "") {
          queryParams.append(key, value);
        }
      });
      queryParams.append("page", 1);
      queryParams.append("limit", pageSize);
      fetchIps(queryParams.toString());
    }
  }, [searchInputs.fromDate, searchInputs.toDate]);

  useEffect(() => {
    getUserList(page, pageSize);
  }, []);

  const handleModalOpen = (value) => {
    setIsModalOpen(value);
  };

  const handleEditModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);
    axios
      .get(`${serverURL}/users/${v._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Decrypt email and phone number
          let userData = response.data.data;
          userData = {
            ...userData,
            emailAddress: userData.email,

            phoneNumber: userData.phoneNumber,
          };

          // Set the decrypted data in state
          setSelectedUserData(userData);

          // Handle modal based on the operation type
          if (operation === "edit") {
            setIsModalOpen(true);
          }
          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching UserPartner:", error);
        setIsActionLoading(false);
      });
  };

  const handleViewModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);

    axios
      .get(`${serverURL}/users/${v}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let userData = response.data.data;

          // Decrypt email and phone number
          userData = {
            ...userData,
            emailAddress: userData.email,

            phoneNumber: userData.phoneNumber,
          };

          // Set the decrypted data
          setSelectedUserData(userData);

          // Handle modal based on the operation type
          if (operation === "read") {
            setUserModalOpen(true);
          }

          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching user:", error);
        setIsActionLoading(false);
      });
  };

  const handleDelete = (e, v) => {
    e.preventDefault();
    setAnchorEl(null);

    Swal.fire({
      icon: "error",
      text: "Do you want to delete?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axios
            .delete(`${serverURL}/users/${v._id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((response) => {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });
              getUserList();
            })
            .catch((error) => {
              console.error("Error deleting User:", error);
              Swal.fire("There was an error deleting the User.");
            });
        } catch (error) {
          console.error(error);
          Swal.fire("There was an error deleting the User.");
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not deleted", "", "info");
      }
    });
  };

  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (
        searchValue !== null &&
        searchValue !== undefined &&
        String(searchValue).trim() !== ""
      ) {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", value);
    queryParams.append("limit", pageSize); // Assuming pageSize is the number of items per page
    await fetchIps(queryParams.toString()); // Fetch first page with new page size
  };
  const getALLDeletedUsers = async () => {
    setTrashLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${serverURL}/users/allDeletedUsers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.success) {
        setALLDeletedUsers(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    } finally {
      setTrashLoading(false);
    }
  };

  const handlePageSizeChange = async (e) => {
    const newSize = parseInt(e.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (
        searchValue !== null &&
        searchValue !== undefined &&
        String(searchValue).trim() !== ""
      ) {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", 1);
    queryParams.append("limit", newSize);

    await fetchIps(queryParams.toString()); // Fetch first page with new page size
  };

  const handleIconOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId); // Set the selected row ID
  };
  const handleIconClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null); // Reset the selected row ID
  };

  const fetchIps = async (queryParams) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/users/get?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setUser(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
        setFilteredIPCount(response?.data?.totalRecords);
        setPage(response?.data?.currentPage);
      }
    } catch (error) {
      console.error("Error fetching filtered vendors:", error);
    } finally {
    }
  };

  const handleSearchChangeHead = (e, key) => {
    const rawValue = e?.target?.value;

    // 👉 text input → lowercase
    // 👉 dropdown (number) → as it is
    const value =
      typeof rawValue === "string" ? rawValue.toLowerCase() : rawValue;

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      const allFieldsEmpty = Object.values(updatedInputs).every(
        (val) => val === "" || val === null || val === undefined,
      );

      if (allFieldsEmpty) {
        getUserList(1, pageSize);
        setFilteredIPCount(0);
        return updatedInputs;
      }

      if (debounceTimeout) clearTimeout(debounceTimeout);

      let queryParams = new URLSearchParams();

      Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
        if (
          searchValue !== "" &&
          searchValue !== null &&
          searchValue !== undefined
        ) {
          queryParams.append(searchKey, searchValue);
        }
      });

      queryParams.append("page", 1);
      queryParams.append("limit", pageSize);

      fetchIps(queryParams.toString());

      return updatedInputs;
    });
  };

  const handleViewClick = (e, id, option) => {
    handleViewModal(e, id, option);
  };
  const handleEditClick = (e, id, option) => {
    handleEditModal(e, id, "edit");
  };

  return (
    <div className={styles.tableGround}>
      <Box>
        {!userListLoading ? (
          <Paper
            sx={{ width: "100%", boxShadow: "none" }}
            className={styles.tableGap}
          >
            <EnhancedTableToolbar
              userVenderData={getUserList}
              setPageSize={setPageSize}
              OnModalOpen={(value) => handleModalOpen(value)}
              onSearchChange={(value) => handleSearchChangeHead(value)}
              totalUsers={totalUsers}
              setSelectedUserData={setSelectedUserData}
              setSearchInputs={setSearchInputs}
              setIsMapState={setIsMapState}
              isMapState={isMapState}
              OnTrashModalOpen={setIsTrashModalOpen}
              getALLDeletedUsers={getALLDeletedUsers}
            />

            <>
              <TableContainer
                className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
              >
                <Table
                  stickyHeader
                  // sx={{ minWidth: 750 }}
                  className="rounded-lg "
                >
                  <EnhancedTableHead
                    ROLE_OPTIONS={ROLE_OPTIONS}
                    rowCount={user?.length}
                    headCells={headCells}
                    userListData={getUserList}
                    setSearchInputs={setSearchInputs} // Function to update search inputs
                    handleSearchChangeHead={handleSearchChangeHead}
                    searchInputs={searchInputs}
                    filteredIPCount={filteredIPCount}
                  />

                  {user && user?.length > 0 ? (
                    <TableBody>
                      {user.map((v, index) => {
                        const role = localStorage.getItem("role");
                        return (
                          <TableRow
                            hover
                            className={styles.tableRowHead}
                            tabIndex={-1}
                            key={v._id}
                            onClick={(e) => {
                              handleViewClick(e, v._id, "read"); // Perform the intended action
                            }}
                          >
                            <TableCell className={styles.tableRow}>
                              <Tooltip
                                title={CapitalizeFirstLetter(v?.name)}
                                arrow
                                placement="top"
                              >
                                <span className="flex flex-row items-center gap-2">
                                  <Avatar
                                    className="custom-avatar"
                                    variant="rounded"
                                    src={v?.profilePhoto || undefined} // 👈 photo aaye to show
                                    style={{
                                      background: v?.profilePhoto
                                        ? "transparent"
                                        : "var(--light-primary-color)",
                                      color: "var(--primary-color)",
                                    }}
                                  >
                                    {/* 👇 photo nahi hoga tab hi letter dikhega */}
                                    {!v?.profilePhoto &&
                                      CapitalizeFirstLetter(v?.name?.charAt(0))}
                                  </Avatar>

                                  <span className="truncate max-w-[180px]">
                                    {CapitalizeFirstLetter(v?.name)}
                                  </span>
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {(() => {
                                const originalEmail =
                                  v?.email || "Not Available";
                                const maskedEmail =
                                  role === "-1"
                                    ? originalEmail
                                    : `**********${Decrypt(
                                        originalEmail,
                                      )?.slice(-7)}`;

                                // Truncate if longer than 17 characters
                                const displayEmail =
                                  maskedEmail.length > 25
                                    ? maskedEmail.substring(0, 25) + "..."
                                    : maskedEmail;

                                return (
                                  <Tooltip
                                    title={originalEmail} // Show full email on hover
                                    arrow
                                    placement="top"
                                    disableHoverListener={
                                      maskedEmail.length <= 25
                                    } // Avoid tooltip when full email is shown
                                  >
                                    <span
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "inline-block",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      {displayEmail}
                                    </span>
                                  </Tooltip>
                                );
                              })()}
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <span>
                                {role === "-1"
                                  ? v?.phoneNumber
                                  : `******${Decrypt(v?.phoneNumber)?.slice(
                                      -4,
                                    )}`}{" "}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <span>{ROLE_MAP[v.role] || "Not Available"}</span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <span>{v?.state || "Not Available"}</span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {(() => {
                                const city = v.city || "Not Available";

                                // Truncate if longer than 17 characters
                                const displayCity =
                                  city.length > 25
                                    ? city.substring(0, 25) + "..."
                                    : city;

                                return (
                                  <Tooltip
                                    title={city} // Show full city name on hover
                                    arrow
                                    placement="top"
                                    disableHoverListener={city.length <= 25} // Show tooltip only if truncated
                                  >
                                    <span
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "inline-block",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      {displayCity}
                                    </span>
                                  </Tooltip>
                                );
                              })()}
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              {" "}
                              <FormatDateTimestamp timestamp={v.createdAt} />
                            </TableCell>

                            {role != 1 && (
                              <TableCell
                                className={styles.tableRow}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="flex justify-center">
                                  <Tooltip title="Click">
                                    <IconButton
                                      onClick={(e) => handleIconOpen(e, v._id)}
                                    >
                                      <MoreVertIcon
                                        style={{
                                          color: "var(--primary-color)",
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={
                                    Boolean(anchorEl) && selectedRowId === v._id
                                  }
                                  onClose={handleIconClose}
                                  keepMounted
                                >
                                  {/* Details Section */}
                                  {isVerified && details && (
                                    <div style={{ marginTop: "2rem" }}>
                                      <h3>Details:</h3>
                                      <pre>
                                        {JSON.stringify(details, null, 2)}
                                      </pre>
                                    </div>
                                  )}

                                  <MenuItem
                                    onClick={(e) => {
                                      handleEditClick(e, v, "edit");
                                      handleIconClose(); // Close the menu
                                    }}
                                    disabled={isActionLoading}
                                  >
                                    <EditOutlinedIcon
                                      style={{ color: "#6b7280" }}
                                    />{" "}
                                    <p className="ml-2 font-semibold text-[#6b7280]">
                                      Edit
                                    </p>
                                  </MenuItem>

                                  {localStorage.getItem("role") == "-1" && (
                                    <MenuItem
                                      onClick={(e) => handleDelete(e, v)}
                                    >
                                      <DeleteOutlinedIcon
                                        style={{ color: "red" }}
                                      />{" "}
                                      <p className="ml-2 font-semibold text-[red]">
                                        Delete
                                      </p>
                                    </MenuItem>
                                  )}
                                </Menu>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={headCells?.length}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No User Found
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200 "
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />

              <div className="flex items-center justify-between ">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                    "& .MuiInputBase-root:before": { borderBottom: "none" },
                    "& .MuiInputBase-root:after": { borderBottom: "none" },
                    "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                  }}
                >
                  <InputLabel
                    id="page-size-label"
                    sx={{
                      position: "static",
                      transform: "none",
                      fontSize: "14px",
                      marginRight: "8px",
                      marginTop: "2px",
                    }}
                  >
                    Rows
                  </InputLabel>
                  <Select
                    labelId="page-size-label"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Rows"
                  >
                    {pageSizeOptions.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <GlobalSnackbar
                  snackbar={snackbar}
                  handleClose={handleSnackbarClose}
                />

                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>
            </>
          </Paper>
        ) : (
          <div className={styles.tableLoading}>
            <CircularProgress />
          </div>
        )}
      </Box>

      {isImage && (
        <Modal
          open={isImage}
          onClose={() => {
            setIsImage(false);
            setSelectedImage(null);
          }}
          className="flex items-center justify-center backdrop-blur-sm"
        >
          <div className="relative w-[500px] h-[450px] bg-[var(--disabled-color)] flex justify-center items-center">
            {/* MUI Close Icon */}
            <IconButton
              onClick={() => {
                setIsImage(false);
                setSelectedImage(null);
              }}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
                bgcolor: "black",
                "&:hover": {
                  bgcolor: "gray",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {selectedImage &&
              (selectedImage.endsWith(".pdf") ? (
                <embed
                  src={selectedImage}
                  type="application/pdf"
                  className="object-contain  min-w-[70%] min-h-[70%] max-w-[80%] max-h-[80%]"
                />
              ) : (
                <img
                  src={selectedImage}
                  alt="Certificate"
                  className="object-contain  min-w-[70%] min-h-[70%] max-w-[80%] max-h-[80%]"
                />
              ))}
          </div>
        </Modal>
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isModalOpen && (
          <UserOnboardingForm
            setSnackbar={setSnackbar}
            getUserList={getUserList}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            selectedUserData={selectedUserData}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isTrashModalOpen && (
          <DeletedUsersRestore
            list={allDeletedUsers}
            type="USERS"
            openModal={isTrashModalOpen}
            loading={isTrashLoading}
            getAllDeletedUsers={getALLDeletedUsers}
            setIsTrashModalOpen={setIsTrashModalOpen}
            setTrashLoading={setTrashLoading}
            getAllList={getUserList}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        userModalOpen && (
          <UserViewModal
            setSnackbar={setSnackbar}
            getUserList={getUserList}
            userModalOpen={userModalOpen}
            setUserModalOpen={setUserModalOpen}
            selectedUserData={selectedUserData}
          />
        )
      )}
    </div>
  );
}
